"use client";
import React from "react";

interface ButtonWithArrowProp {
  title: string;
  minSize?: number;
  color?: string; // #onlyhash form
  underLineOnHover?: boolean;
  position?: string;
  onClick?: any;
  font?: any;
}
const ButtonWithArrow = ({
  title,
  color,
  minSize,
  underLineOnHover,
  position,
  onClick,
  font="font-cambonExtraLightItalic"
}: ButtonWithArrowProp) => {
  let fontSize = "14px";
  if (minSize && minSize > 0) {
    fontSize = `${minSize}px`;
  }
  let placeAt = "";
  switch (position) {
    case "center":
      placeAt = "mx-auto";
      break;
    case "left":
      placeAt = "text-start";
      break;
    case "right":
      placeAt = "text-end";
      break;
    default:
      placeAt = "";
      break;
  }

  return (
    <button
      className={`text-white flex justify-center items-center transition-all duration-300 group ${placeAt} `}
      onClick={onClick}
    >
      <span
        style={{ color: color }}
        className={`${font}  text-[${fontSize}] md:text-[${fontSize}] lg:text-[${fontSize}] text-[${color}] tracking-[0.47px] ${
          underLineOnHover ? "group-hover:underline" : ""
        }`}
      >
        {title}
      </span>
      <img
        src={` ${
          color ? "/ic_right_arrow_rgb.svg" : "/ic_right_arrow_white.svg"
        }`}
        className={`h-2.5 w-auto mt-2 group-hover:translate-x-[22px] p-0.5 mb-md:p-0  duration-300 ease-in`}
        alt=""
      />
    </button>
  );
};

export default ButtonWithArrow;
